export default "/assets/images/mila-with-dimensions.8739fb0c200e5a54.png";